module.exports = __webpack_public_path__ + "media/images/file-icons/256/003-interface-88764430cd461dd3ed6321135cc2606a.png";